import { useState } from "react";
import type { TripWorkspace } from "@japangolmok/core";
import type { PersistTrip } from "../trips/TripExperience";
import { track } from "../analytics/events";
declare global {
	interface Window {
		__jgmWatchRewardedBook?: (group: string) => Promise<boolean>;
	}
}
const groupId = ""; // Activating a group is outside this release approval.
export function RewardedBookOffer({
	trip,
	persist,
}: {
	trip: TripWorkspace;
	persist: PersistTrip;
}) {
	const [notice, setNotice] = useState("");
	return (
		<aside className="book-offer">
			<h3>여행책 특별판</h3>
			<p>
				큰 인쇄 판형과 표지 기능은 준비 중이에요. 가격은 아직 정해지지 않았어요. 기본 여행책은 계속 무료예요.
			</p>
			<button
				type="button"
				className="button secondary"
				onClick={async () => {
					track("premium_interest");
					if (!groupId || !window.__jgmWatchRewardedBook) {
						setNotice(
							"준비 중이에요. 기본 여행책은 지금도 무료로 받을 수 있어요.",
						);
						return;
					}
					const earned = await window.__jgmWatchRewardedBook(groupId);
					if (earned) {
						await persist((t) => {
							t.bookTheme = "navy";
						});
						setNotice("특별판을 이 여행에 열었어요.");
					} else setNotice("보상 없이 닫혔어요. 다시 시도해 주세요.");
				}}
			>
				큰 여행책·표지 3종 알아보기
			</button>
			{trip.bookTheme && (
				<label>
					표지 테마
					<select
						value={trip.bookTheme}
						onChange={(e) =>
							void persist((t) => {
								t.bookTheme = e.target.value;
							})
						}
					>
						<option value="navy">승강장 남색</option>
						<option value="red">골목 주홍</option>
						<option value="forest">숲 이끼색</option>
					</select>
				</label>
			)}
			<p role="status">{notice}</p>
			<p>
				현재 광고 요청과 유료 결제는 하지 않아요. 기기를 바꿀 때 기존 특별판
				설정은 전체 백업으로 옮겨요.
			</p>
		</aside>
	);
}
